
export default {
  filters: {
    money(value) {
      if (!value) {
        return null;
      }
      return value.toString().replace('.', ',');
    },
  },
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
    text: {
      type: String,
      default: '',
    },
    ingredients: {
      type: String,
      default: '',
    },
    kitchen: {
      type: String,
      default: '',
    },
    persons: {
      type: Number,
      default: null,
    },
    preperation: {
      type: String,
      default: '',
    },
    preperationTime: {
      type: String,
      default: '00:00',
    },
    price: {
      type: Number,
      default: null,
    },
    level: {
      type: Number,
      default: null,
    },
    waitingTime: {
      type: String,
      default: '00:00',
    },
    shopUrl: {
      type: String,
      default: null,
    },
    author: {
      type: String,
      default: '',
    },
    stars: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    print() {
      window.print();
    },
  },
};
